import request from './core/request'

// 首页
export default {
	//获取达人信息、店铺装修、店铺主题
	getExpertConfig: () => request.get(`/mobile/getExpertConfig`),
	// 获取首页数据
	getHomeData: () => request.get(`/mobile/getHomeData`),
	// 获取套装数据
	getOutFitsList: (params = {}) => request.get(`/mobile/getOutFitsList`, params),
}